let saveProjectTimeout: NodeJS.Timeout | null = null;
export const getSaveProjectTimeout = () => saveProjectTimeout;
export const setSaveProjectTimeoutGlobal = (newTimeout: NodeJS.Timeout | null) => {
  saveProjectTimeout = newTimeout;
};
export const clearSaveProjectTimeout = () => {
  if (saveProjectTimeout) {
    clearTimeout(saveProjectTimeout);
  }
  saveProjectTimeout = null;
};

let saveProjectByFieldsTimeout: NodeJS.Timeout | null = null;
export const getSaveProjectByFieldsTimeout = () => saveProjectByFieldsTimeout;
export const setSaveProjectByFieldsTimeoutGlobal = (newTimeout: NodeJS.Timeout | null) => {
  saveProjectByFieldsTimeout = newTimeout;
};
export const clearSaveProjectByFieldsTimeout = () => {
  if (saveProjectByFieldsTimeout) {
    clearTimeout(saveProjectByFieldsTimeout);
  }
  saveProjectByFieldsTimeout = null;
};
